/**
 * studioWebFontsEnv — which segmently-assets bucket Studio surfaces load
 * web fonts from ({env} substitution in catalog URLs).
 *
 * Hostname heuristic instead of import.meta.env on purpose: import.meta
 * breaks jest's CJS transform for every module that (transitively) imports
 * the file. Curated fonts are uploaded to all three buckets, so a wrong
 * guess still renders; project-uploaded fonts (Phase 2) live only in their
 * own env's bucket, which these rules resolve correctly for the standard
 * Studio hosts (localhost / *dev* / *stage* / production).
 *
 * @module font-config/utils
 */

import type { WebFontsEnv } from '../data/googleFontCatalog';

export function getStudioWebFontsEnv(): WebFontsEnv {
  if (typeof window === 'undefined') return 'dev';
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return 'dev';
  if (host.includes('stage')) return 'stage';
  if (host.includes('dev')) return 'dev';
  return 'prod';
}
